import { isNil } from "lodash";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import FormButton from "../../../components/form/FormButton";
import FormTextField from "../../../components/form/FormTextField";
import ModalField from "../../../components/modal/ModalField";
import ModalGroup from "../../../components/modal/ModalGroup";
import ModalRow from "../../../components/modal/ModalRow";
import { PropTypeShapes } from "../../../types";
import preprocessorQuery from "../../../utils/preprocessorQuery";
import userInputValidators from "../../../utils/userInputValidators";

const CalendarSettingsMonthDetailView = props => {
  const isIos = preprocessorQuery.isIos();

  const index = props.selectedItem;
  const m = props.months.get(index);
  if (isNil(index)) {
    return null;
  }

  return (
    <Fragment>
      <ModalGroup>
        <ModalRow>
          <ModalField label="Name">
            <FormTextField
              value={m.name}
              autoFocusOnEmpty={true}
              onChange={label => props.onMonthNameChange(index, label)}
              validator={userInputValidators.noEmpty}
            />
          </ModalField>
          <ModalField label="Abbreviated Name">
            <FormTextField
              value={m.shortName}
              onChange={label => props.onMonthShortNameChange(index, label)}
              validator={userInputValidators.noEmpty}
            />
          </ModalField>
        </ModalRow>
        <ModalRow>
          <ModalField label="Days in Regular Year">
            <FormTextField
              value={m.normalDuration}
              numeric={true}
              isInteger={true}
              onChange={duration => props.onMonthDurationChange(index, duration)}
              min={0}
              disabled={!props.canEditDateData}
              validator={userInputValidators.noEmpty}
            />
          </ModalField>
          <ModalField label="Days in Leap Year">
            <FormTextField
              value={m.leapDuration}
              numeric={true}
              isInteger={true}
              onChange={duration => props.onMonthLeapDurationChange(index, duration)}
              min={0}
              disabled={!props.canEditDateData}
              validator={userInputValidators.noEmpty}
            />
          </ModalField>
        </ModalRow>
      </ModalGroup>
      {isIos && props.canDelete ? (
        <ModalGroup>
          <ModalRow>
            <div className="settingsDetailDeleteButton">
              <FormButton destructive={true} label="Delete" onClick={props.onDeleteClick} />
            </div>
          </ModalRow>
        </ModalGroup>
      ) : null}
    </Fragment>
  );
};

CalendarSettingsMonthDetailView.propTypes = {
  months: ImmutablePropTypes.listOf(PropTypeShapes.month).isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  selectedItem: PropTypes.number,
  onAddMonth: PropTypes.func.isRequired,
  onRemoveMonth: PropTypes.func.isRequired,
  onMonthNameChange: PropTypes.func.isRequired,
  onMonthShortNameChange: PropTypes.func.isRequired,
  onMonthDurationChange: PropTypes.func.isRequired,
  onMonthLeapDurationChange: PropTypes.func.isRequired,
  canEditDateData: PropTypes.bool.isRequired,
  canDelete: PropTypes.bool,
  onDeleteClick: PropTypes.func
};

export default CalendarSettingsMonthDetailView;
